import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { ProductActionsSelectVariantTemplateRootParamList } from "../../../../types";
import { ProductActionsSelectVariantTemplateScreen } from "../ProductActionsSelectVariantTemplateScreen";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { ProductActionsSelectVariantTemplateOptionValuesRootScreen } from "../ProductActionsSelectVariantTemplateOptionValuesRootScreen";

export const ProductActionsSelectVariantTemplateRootScreen = () => {
  const RootNavigator =
    createStackHeaderNavigator<ProductActionsSelectVariantTemplateRootParamList>();

  return (
    <RootNavigator.Navigator
      screenOptions={{
        headerShown: true,
        headerLeft: () => <ModalCloseButton type="Back" />,
        animationEnabled: true,
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        title: "",
      }}
    >
      <RootNavigator.Screen
        name="ProductActionsSelectVariantTemplateScreen"
        component={ProductActionsSelectVariantTemplateScreen}
      />
      <RootNavigator.Screen
        options={{
          headerShown: false,
        }}
        name="ProductActionsSelectVariantTemplateOptionValuesRootScreen"
        component={ProductActionsSelectVariantTemplateOptionValuesRootScreen}
      />
    </RootNavigator.Navigator>
  );
};
